/** Key codes in the v11 `deleteKeyCode` shape: one key, a list (null entries ignored), or null for none. */
export type KeyCodes = string | (string | null)[] | null;

/** v11 matches a configured key against both `event.key` and `event.code`. */
export const matchesKey = (event: KeyboardEvent, keyCodes: KeyCodes): boolean => {
  const codes = (Array.isArray(keyCodes) ? keyCodes : [keyCodes]).filter((code): code is string => Boolean(code));
  return codes.includes(event.key) || codes.includes(event.code);
};

const TYPING_TAGS = new Set(['INPUT', 'SELECT', 'TEXTAREA']);

/** Keys pressed while typing (form fields, contenteditable, `.nokey`) must not delete anything (v11). */
export const isTypingTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) return false;
  return TYPING_TAGS.has(target.nodeName) || target.hasAttribute('contenteditable') || target.closest('.nokey') !== null;
};
